import type { SVGProps } from "react";
import { memo } from "react";
const MigrationEvaluator = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#055F4E" />
        <stop offset="100%" stopColor="#56C0A7" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M40.359 43.859c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5m0-9a5.506 5.506 0 0 0-5.5 5.5c0 3.033 2.468 5.5 5.5 5.5s5.5-2.467 5.5-5.5-2.468-5.5-5.5-5.5m8.069 12.097a1 1 0 0 0-.507.507l-7.464 16.793-7.416-16.685a1 1 0 0 0-.508-.507l-16.071-7.143 16.557-7.36a1 1 0 0 0 .508-.507l6.93-15.592 6.978 15.7c.101.226.281.407.508.508l16.313 7.251zm9.018 10.422L47.418 53.52l2.174-4.893 3.833-1.704zm-34.174-.242 3.941-10.248 4.156 1.847 2.007 4.516zm.379-33.554 9.78 3.761-1.576 3.547-4.606 2.047zm33.416-.241-3.677 9.561-4.283-1.904-1.744-3.925zm10.058 15.666L55.22 33.715l4.522-11.756a1 1 0 0 0-1.293-1.293l-11.901 4.577-5.177-11.65a1.002 1.002 0 0 0-1.828 0l-5.298 11.92-11.976-4.606a1.001 1.001 0 0 0-1.293 1.292l4.443 11.552-11.826 5.256a1 1 0 0 0 0 1.827l11.79 5.241-4.786 12.444a1.003 1.003 0 0 0 .934 1.359 1 1 0 0 0 .359-.067l12.299-4.731 5.354 12.045a1.001 1.001 0 0 0 1.828 0l5.233-11.774 12.224 4.701q.176.066.359.066a1 1 0 0 0 .934-1.359L55.255 46.11l11.87-5.276a1 1 0 0 0 0-1.827"
      />
    </g>
  </svg>
);
const Memo = memo(MigrationEvaluator);
export default Memo;
